import React from 'react';
import clsx from 'clsx';
import type { ConnectionState } from '@ac/client';

interface ConnectionIndicatorProps {
  state: ConnectionState;
}

export function ConnectionIndicator({ state }: ConnectionIndicatorProps) {
  const labels: Record<ConnectionState, string> = {
    connected: 'Connected',
    connecting: 'Connecting...',
    disconnected: 'Disconnected',
    offline: 'Offline'
  };

  return (
    <div className="flex items-center gap-2">
      <div
        className={clsx(
          'connection-indicator',
          state
        )}
        aria-label={`Connection status: ${labels[state]}`}
      />
      <span className="text-xs text-gray-400 hidden sm:inline">
        {labels[state]}
      </span>
    </div>
  );
}